export const GRAPH_EVENTS = {
  OPS_ADD_TO_STAGED: 'graph.ops.add-to-staged',
};
